<ng-progress
#progressBar
ngProgressHttp
meteor = "false"
color = '#fff'
thick = "true"

direction ="ltr+"
speed = "200"
trickleSpeed = "200"
fadeOutSpeed = "50"
debounceTime = "0"
flat = "false"
spinner = "true"
spinnerPosition = "right"
relative = "false"
min = "20"
max = "100"></ng-progress>
<div *ngIf="!isLoading">
    <header>
        <app-masthead-component userId={{userId}} preferredFM={{preferredFM}}></app-masthead-component>
    </header>
    <app-landing></app-landing>
</div>

<div *ngIf="isLoading && !isError">
    <header>
        <app-masthead-component userId={{userId}} preferredFM={{preferredFM}}></app-masthead-component>
    </header>
    <app-loading></app-loading>
</div>
<div *ngIf="isError">
    <header>
        <app-masthead-component userId={{userId}} preferredFM={{preferredFM}}></app-masthead-component>
    </header>
    <p style="text-align: center; font-weight: bold;margin: 4rem;color: var(--dell-red);padding-top:15%">{{errorMessage}}</p>
</div>
